export const LINK_TYPES = {
  WEB: 'WEB_LINK',
  AUTH: 'AUTH_LINK',
};

export const VERTICAL_IMAGE_SIZE = 104;
